import React, { useState } from "react";

function UploadImage({ uploadImage ,fileName}) {  
  // uploadImage(event.target.files[0]); // Uncomment this line when you want to upload the file
  return (
    <div>
      <label
        htmlFor="fileInput"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {fileName?.name && fileName.name.length > 8
            ? fileName.name.substring(0, 8) + "..."
            : fileName?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        multiple
        id="fileInput"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={uploadImage}
      />
    </div>
  );
}

export default UploadImage;
